<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="500"
        v-model="dateAtencionForm.isOpen"
        eager
        persistent
        scrollable
    >
        <v-form>
            <v-card>
                <h2
                    class="
                        font-weight-light
                        primary--text
                        px-8
                        pt-4
                        text-center
                    "
                >
                    Editando Fecha de {{ dateAtencionForm.father }}
                </h2>
                <div
                    class="overline d-flex justify-center"
                    style="background-color: #c5cde0"
                >
                    {{
                        dateAtencionForm.form.cliente
                            ? dateAtencionForm.form.cliente.nombre
                            : 'Sin nombre'
                    }}
                </div>
                <!-- <div
                    class="overline d-flex justify-center"
                    style="background-color: #c5cde0; border-top: solid 1px"
                >
                    Antigua fecha
                    {{ parseDate(fechaContacto) }}
                </div> -->
                <!-- FORMULARIO -->
                <div class="d-flex justify-space-around px-6 pt-2">
                    <v-text-field
                        class="mx-1"
                        v-model="formatUpdateOn"
                        label="Antigua fecha"
                        prepend-icon="mdi-calendar"
                        readonly
                    ></v-text-field>
                    <v-text-field
                        class="mx-2"
                        v-model="formatUpdatedOnNew"
                        label="Nueva fecha"
                        prepend-icon="mdi-calendar"
                        readonly
                    ></v-text-field>
                </div>
                <div class="d-flex justify-center ma-4">
                    <v-date-picker
                        v-model="newUpdatedOn"
                        year-icon="mdi-calendar-blank"
                        prev-icon="mdi-skip-previous"
                        next-icon="mdi-skip-next"
                        :max="
                            new Date(
                                Date.now() -
                                    new Date().getTimezoneOffset() * 60000
                            )
                                .toISOString()
                                .substr(0, 10)
                        "
                        landscape
                        locale="es-es"
                        elevation="0"
                    ></v-date-picker>
                </div>
                <div
                    class="
                        ma-0
                        d-flex
                        justify-center
                        caption
                        red--text
                        my-2
                        font-weight-medium
                    "
                    v-if="!validForm"
                >
                    ¡Las fechas no pueden ser iguales, elige una nueva fecha!
                </div>
                <v-progress-linear
                    v-if="dateAtencionForm.isLoading"
                    color="#304FFE"
                    indeterminate
                    rounded
                    height="6"
                ></v-progress-linear>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                        depressed
                        color="success"
                        :disabled="!validForm"
                        @click="submit"
                    >
                        Editar
                    </v-btn>
                    <v-btn color="red" text @click="closeDialog">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'FormAtencion',
    data: () => ({
        activePicker: null,
        menu: false,
        newUpdatedOn: null,
        validForm: true,
    }),
    computed: {
        ...mapState('areaPersonal/calculadora', {
            dateAtencionForm: (state) => state.dateAtencionForm,
            updatedOn: (state) => state.dateAtencionForm.form.updatedOn,
        }),
        formatUpdateOn() {
            if (!this.updatedOn) return null;
            const [year, month, day] = new Date(
                this.dateAtencionForm.form.updatedOn
            )
                .toISOString()
                .split('T')[0]
                .split('-');
            return `${month}/${day}/${year}`;
        },
        formatUpdatedOnNew() {
            if (!this.newUpdatedOn) return null;
            const [year, month, day] = this.newUpdatedOn.split('-');
            return `${month}/${day}/${year}`;
        },
    },
    methods: {
        ...mapActions('areaPersonal/calculadora', ['updateAtencion']),
        parseDate(date) {
            return (
                new Date(date)
                    .toLocaleString('es-ES', { timeZone: 'UTC' })
                    .replace(' ', ' -  (') + ')'
            );
        },
        isSameDate() {
            return this.formatUpdatedOnNew == this.formatUpdateOn;
        },
        submit() {
            this.updateAtencion(this.newUpdatedOn).then(() => {
                this.closeDialog();
            });
        },
        closeDialog() {
            let dateAtencionForm = {
                isOpen: false,
                isEditing: false,
                isLoading: false,
                form: {
                    updatedOn: null,
                },
            };
            this.$store.commit(
                'areaPersonal/calculadora/dateAtencion',
                dateAtencionForm
            );
        },
    },
    watch: {
        updatedOn() {
            this.newUpdatedOn = new Date(this.dateAtencionForm.form.updatedOn)
                .toISOString()
                .split('T')[0];
        },
        newUpdatedOn() {
            this.validForm = !this.isSameDate();
        },
    },
};
</script>
